import React from "react";

const SendIcon = ({
  style = { height: "2vh", width: "2vh" },
  color = "white",
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={style}>
      <g>
        <g>
          <path
            d="M492.723,0.632c-0.026,0.007-0.051-0.005-0.077,0.002L10.641,149.203C4.309,151.137,0,156.97,0,163.581
          c0,6.595,4.338,12.429,10.641,14.349l189.79,59.397l-8.912,66.323c-1.347,9.679,6.936,18.164,16.855,16.869l66.317-8.924
          l59.403,189.715c1.905,6.331,7.738,10.655,14.363,10.655c6.596,0,12.429-4.323,14.363-10.641l148.556-481.96
          c0.007-0.024-0.005-0.051,0.002-0.075C514.786,7.954,503.573-2.618,492.723,0.632z M277.141,280.977l-53.26,7.167l7.152-53.29
          L419.95,92.058L277.141,280.977z"
            fill={color && color}
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M135.298,291.822c-5.862-5.862-15.36-5.862-21.222,0c-21.486,21.486-46.313,39.381-73.75,53.173
          c-7.416,3.723-10.376,12.736-6.654,20.153c2.609,5.246,7.914,8.265,13.396,8.265c2.286,0,4.572-0.513,6.742-1.598
          c30.309-15.228,57.716-35.013,81.488-58.771C141.16,307.182,141.16,297.684,135.298,291.822z"
            fill={color && color}
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M220.187,376.709c-5.862-5.862-15.359-5.861-21.222,0.001c-28.931,28.931-62.172,53.334-98.812,72.518
          c-7.358,3.84-10.2,12.912-6.36,20.255c2.696,5.115,7.914,8.046,13.308,8.046c2.345,0,4.749-0.542,6.947-1.715
          c39.367-20.592,75.069-46.797,106.14-77.883C226.049,392.069,226.049,382.571,220.187,376.709z"
            fill={color && color}
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M177.743,334.267c-5.862-5.862-15.36-5.862-21.222,0c-37.637,37.623-84.214,66.422-134.719,83.262l-9.497,3.166
          c-7.856,2.608-12.106,11.11-9.497,18.98c2.11,6.287,7.973,10.259,14.245,10.259c1.583,0,3.166-0.249,4.749-0.776l9.497-3.166
          c54.902-18.306,105.554-49.596,146.444-90.502C183.606,349.626,183.606,340.129,177.743,334.267z"
            fill={color && color}
          />
        </g>
      </g>
    </svg>
  );
};

export default SendIcon;
